import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@stockcare-services/authentication/authentication.service';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';

@Component({
  standalone: false,
  selector: 'app-device-deactivated',
  templateUrl: './device-deactivated.component.html',
  styleUrls: ['./device-deactivated.component.scss']
})
export class DeviceDeactivatedComponent implements OnInit {
  isAdmininistrator: boolean;
  constructor(
    private deviceService: DeviceService,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.initialize();
  }

  private initialize() {
    this.isAdmininistrator = this.authService.isAdministrator();
    if (!this.isAdmininistrator) {
      this.authService.logout();
    }
  }

  recheck() {
    if (!this.deviceService.isDeviceRemoved()) {
      this.router.navigate(['']);
    }
  }

  returnToLogin() {
    this.router.navigate(['']);
  }

  activate() {
    const device = this.deviceService.getDeviceFromLocalStorage();
    device.isRemoved = false;

    this.deviceService.update(device).subscribe(() => {
      this.recheck();
    });
  }
}
